var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.iconName
    ? _c("div", { staticClass: "svg-icon" }, [
        _c(
          "svg",
          {
            staticClass: "custom-icon",
            style: { fill: _vm.iconColor },
            attrs: { width: _vm.size, height: _vm.size },
          },
          [
            _c("use", {
              attrs: {
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "xlink:href": _vm.iconId,
              },
            }),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }